import React, { useContext } from "react";
import { PurchaseValidationContext } from "../../PurchaseValidationContext";
import { AllTransactionsTable } from "./AllTransactionsTable";

export const AccountTransactionsTab = () => {
  const { accounts, accountModal } = useContext(PurchaseValidationContext);

  const accountId = accountModal?.accountId;
  const account = accounts.find((acc) => acc.id === accountId) ?? {};

  return (
    <div className="p-4">
      <AllTransactionsTable account={account} />
    </div>
  );
};
